module.exports = __webpack_public_path__ + "img/cal.147b91e5.svg";